<template>
  <div>
    <div class="mod" v-click-outside="unfocus" v-if="!success">
      <div v-show="!focused" @focus="focus" @click="focus" tabindex="0">
        <span class="placeholder">
          Enter Your Email<br>
          To Get The Newsletter
        </span>
        <span class="button"><img src="./SendTriangle.svg" width="20" height="20"></span>
      </div>
      <div v-show="focused">
        <input type="email" @input="removeError" ref="input" v-model="email" @focus="focus" @keyup.enter="submit" @keyup.shift.tab="unfocus">
        <button class="button" ref="button" @click="submit" @focus="focus" @keyup.tab="unfocus"><img src="./SendTriangle.svg" width="20" height="20"></button>
      </div>
      <div class="notification is-danger" v-if="error">{{ error }}</div>
    </div>
    <div class="mod success" v-else>
      <div>
        <span class="placeholder" :style="{ textAlign: 'left' }">Thank you<br> for subscribing!</span>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'newsletter-module',
  data () {
    return {
      focused: false,
      email: '',
      success: false,
      error: null
    }
  },
  beforeMount () {
    if (sessionStorage.getItem('newsletterSubscribe')) {
      this.success = true
    }
  },
  methods: {
    focus () {
      this.focused = true
      process.nextTick(() => {
        this.$refs.input.focus()
      })
    },
    unfocus () {
      if (!this.email) {
        this.focused = false
      }
    },
    removeError () {
      this.error = null
    },
    submit () {
      let vm = this
      // POST /subscribe => newsletter_subscribe() [theme-folder]/api/functions.php
      vm.$axios.post('/subscribe', {
        email: vm.email
      })
      .then((response) => {
        if (response.data.success) {
          vm.unfocus()
          vm.email = ''
          vm.success = true
          vm.error = null
          sessionStorage.setItem('newsletterSubscribe', true)
        } else {
          vm.error = response.data.data.message
          setTimeout(() => {
            vm.error = null
          }, 5000)
        }
      })
    }
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="sass" scoped>

  .mod
    display: flex
    position: relative
    &.success
      > div
        padding-top: 3px
        border-bottom: none
    > div
      display: flex
      text-align: left
      line-height: 1.1
      position: relative
      border-bottom: 1px solid
      input, 
      input
        padding-bottom: 10px
        border: none
        width: 170px
        height: 36px
      .button
        border: 0
        padding: 0
        height: 36px
        position: absolute
        right: 0
      .placeholder
        width: 170px
        height: 36px
        padding-top: 3px
        padding-right: 20px
        font-size: 13px
    .notification
      position: absolute
      top: calc(100% + 8px)
      width: 100%
      font-size: 12px
      padding: 0.5em 1em
</style>



// WEBPACK FOOTER //
// NewsletterModule.vue?11cb77e8